import request from "@/utils/request";

export default function agentGetCardNumList() {
    return request({
        url: `/user/card/agentGetCardNumList`,
    })
}